export enum PropertySelectState {
    ALL,
    SOME,
    NONE,
}
